function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "16",
  viewBox: "0 0 12 16"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M6 0c3.305 0 6 2.546 6 5.708 0 2.007-1.745 5.266-5.23 9.905a.959.959 0 01-1.54 0C1.745 10.974 0 7.715 0 5.708 0 2.546 2.695 0 6 0zm0 1.936c-2.38 0-4.296 1.81-4.296 4.022 0 1.445 1.431 4.14 4.296 7.978 2.865-3.837 4.296-6.533 4.296-7.978 0-2.213-1.916-4.022-4.296-4.022zm0 1.568c1.39 0 2.516 1.214 2.516 2.711C8.516 7.712 7.39 8.926 6 8.926c-1.39 0-2.516-1.214-2.516-2.711C3.484 4.718 4.61 3.504 6 3.504zm0 1.251c-.748 0-1.355.654-1.355 1.46 0 .806.607 1.46 1.355 1.46s1.355-.654 1.355-1.46c0-.806-.607-1.46-1.355-1.46z"
}));